import { useMemo } from 'react';

import { getProductInfoDialogProducts } from '../api';
import type { GetProductInfoDialogProductsProps } from '../api';
import type { Product } from '../models';
import { useSWRFetch } from './internal/useSWRFetch';

export const useGetProductInfoDialogProducts = ({
  atpClusterId,
  currentLanguage,
  customerId,
  globalApiUrl,
  graphqlUrl,
  productCodes,
  tenant,
  token,
}: GetProductInfoDialogProductsProps) => {
  const { data, error, fetch, isLoaded, isLoading } = useSWRFetch({
    fallback: [] as Product[],
    fetcher: async () =>
      getProductInfoDialogProducts({
        atpClusterId,
        currentLanguage,
        customerId,
        globalApiUrl,
        graphqlUrl,
        productCodes,
        tenant,
        token,
      }),
    key: [atpClusterId, customerId, globalApiUrl, graphqlUrl, tenant, token, ...productCodes],
  });

  return useMemo(
    () => ({ data, error, fetch, isLoaded: isLoaded && data.length > 0, isLoading }),
    [data, error, fetch, isLoaded, isLoading],
  );
};
